import {
  FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_PENDING,
  FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_REJECTED,
  FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_FULFILLED,
  SET_CLICK_AND_COLLECT_ORDER_DETAIL_SELECTED_IDS,
} from '../constants/clickAndCollectOrderDetail';

const initialState = {
  pending: true,
  clickAndCollectOrderDetail: {
    stockLocation: {},
    state: {},
    shippingAddress: {},
  },
  selectedIds: {},
  error: {},
};

export const clickAndCollectOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        clickAndCollectOrderDetail: action.data,
        pending: false,
        error: {},
      };

    case SET_CLICK_AND_COLLECT_ORDER_DETAIL_SELECTED_IDS:
      return {
        ...state,
        selectedIds: action.data,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/clickAndCollectOrderDetail.js